import Component from '../abstracts/Component';
// quick refactoring of privacyComponent
export default class PrivacyComponent extends Component {
  get SELECTORS() {
    return {
      Form: '.js-validate-form',
      privacyCheckbox: '.js-wrapper-privacy'
    };
  }

  constructor() {
    super();
    this.Form = $(this.SELECTORS.Form);
    this.privacyCheckbox = $(this.SELECTORS.privacyCheckbox);
  }

  basicPrivacyAcceptance() {
    let ctx = this;
    let isKr = document.body.dataset.website === 'kr';

    if (!isKr) {
      if ( ctx.privacyCheckbox.length > 0 && ctx.privacyCheckbox.prop('checked') ){
        ctx.privacyCheckbox.parents('form').find('button').removeAttr('disabled');
      }

      ctx.$on('change', ctx.triggerButtonDisabling, 'body', '.js-wrapper-privacy');
    }
  }

  triggerButtonDisabling(e) {
    e.event.stopImmediatePropagation();
    let checked = $(e.event.currentTarget).prop('checked');
    if(checked)
      $(e.event.currentTarget).parents('form').find('button').removeAttr('disabled');
    else
      $(e.event.currentTarget).parents('form').find('button').attr('disabled','true');

  }

  render() {
    super.render();
    this.basicPrivacyAcceptance();
  }
}
